import React from 'react';
 
function Section(props) {
    const { children, className } = props;

    return <section className={["container", className].join(" ")}>{children}</section>
}
 
export default Section;